module.exports = __webpack_public_path__ + "img/92.2992dfb5.jpg";